import { Box, Paper, Typography } from "@mui/material";
import LinearProgressWithLabel from "components/LinearProgressWithLabel";
import React from "react";

const ProductImageUploadStatus = ({
  file,
  progress = 0,
  status = "pending",
}) => {
  return (
    <Paper
      sx={{
        display: "flex",
        height: 80,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 2,
      }}
      elevation={1}
    >
      <Box
        display="flex"
        sx={{
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          alt=""
          src={file.preview}
          style={{
            width: 80,
            height: 80,
            objectFit: "contain",
            marginLeft: 3,
          }}
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
        />
        <LinearProgressWithLabel value={progress} status={status} />
        <Typography margin={1}>{status}</Typography>
      </Box>
    </Paper>
  );
};

export default ProductImageUploadStatus;
